module.exports = __webpack_public_path__ + "img/mavigok.39ed7733.png";